export class CustomerFeedback {
    public readonly taste: boolean;
    public readonly sleep: boolean;
    public readonly heartburn: boolean;
    public readonly farmers: boolean;
    public readonly bloodPressure: boolean;
    public readonly overall: number;
    public readonly customFeedback: string;
    public readonly allowPublishing: boolean;

    constructor(json: any) {
        this.taste = json.taste;
        this.sleep = json.sleep;
        this.heartburn = json.heartburn;
        this.farmers = json.farmers;
        this.bloodPressure = json.bloodPressure;
        this.overall = json.overall;
        this.customFeedback = json.customFeedback;
        this.allowPublishing = json.allowPublishing;
    }
}
